import * as React from "react";
import { useEffect, useState } from "react";
import { getCookieValue, setCookie } from "../helper/cookies";
import { RevoLoggedInMenu } from "./revo-loggedin-menu";
import { RevoLogoutWrapper } from "./revo-logout-wrapper";
import { getCurrentDomain, getSanitizedDomain, getServiceName, } from "../helper/domain";
import { axiosCallWithLocalhostFallback } from "../helper/axios";
import { scopesFromCookie } from "../helper/scopesfromcookie";
import { filterObject } from "./util/filter-object";
const RevoLastPathCookie = "TS_REVO_MAIN_MENU_LAST_PATH";
export const persistUserApplicationPath = (customerId) => {
    if (customerId) {
        const inOneYear = new Date();
        inOneYear.setFullYear(new Date().getFullYear() + 1);
        const cookiePath = getCookieValue(RevoLastPathCookie);
        let previousPaths = cookiePath ? JSON.parse(cookiePath) : {};
        const newServiceName = getServiceName(window.location);
        const newPath = window.location.pathname.split("/", 3).slice(1).join("/");
        const maxCustomerRecords = 2;
        const customerSettings = filterObject(previousPaths, ([key]) => key.startsWith("customer/"));
        customerSettings[`customer/${customerId}`] = {
            service: newServiceName !== null && newServiceName !== void 0 ? newServiceName : "",
            path: newPath,
            ts: Math.round(Date.now()),
        };
        let customerPaths = Object.entries(customerSettings).sort(([, value1], [, value2]) => {
            return (value2.ts || 0) - (value1.ts || 0);
        });
        if (customerPaths.length > maxCustomerRecords) {
            customerPaths.length = maxCustomerRecords;
        }
        const newCookieData = Object.fromEntries(customerPaths);
        setCookie(RevoLastPathCookie, JSON.stringify(newCookieData), inOneYear, getSanitizedDomain(window.location));
    }
};
export const RevoMenu = () => {
    const [user, setUser] = useState(null);
    useEffect(() => {
        axiosCallWithLocalhostFallback({
            domain: getCurrentDomain(window.location),
            serviceName: "dashboard",
            pathWithoutLeadingSlash: "api/profile",
        }, { withCredentials: true }, {
            name: "Pro",
            surname: "Skillz",
            language: "de",
            email: "hans@hans.de",
            id: "abc",
            trackingAllowed: false,
            companyId: null,
        }, 200)
            .then((data) => {
            setUser(data.data);
            persistUserApplicationPath(data.data.id);
        })
            .catch(() => { });
    }, []);
    const cookieValue = !!scopesFromCookie().length;
    if (cookieValue) {
        return React.createElement(RevoLoggedInMenu, { user: user });
    }
    else {
        return (React.createElement(RevoLogoutWrapper, null,
            React.createElement("div", { id: "revo-content", style: { height: "100vh" } })));
    }
};
//# sourceMappingURL=revo-menu.js.map